import { apiClient } from './client';
import { EmployeeDocument } from '../types/documents';

/** Generic per-record documents, for any module besides Employee - see generic-document.controller.ts. */
export const genericDocumentApi = {
  listFor: (entityType: string, entityId: number) =>
    apiClient.get<{ data: EmployeeDocument[] }>(`/api/documents/${entityType}/${entityId}`),
  uploadFor: (entityType: string, entityId: number, input: { fileDataUri: string; originalFilename: string; documentType: string; category: string }) =>
    apiClient.post<{ data: { id: number } }>(`/api/documents/${entityType}/${entityId}`, input),
  downloadUrl: (entityType: string, documentId: number) => `/api/documents/${entityType}/file/${documentId}`,
  deleteFor: (entityType: string, documentId: number) =>
    apiClient.delete<{ data: { id: number; deleted: boolean } }>(`/api/documents/${entityType}/file/${documentId}`),
};
